export class HTMLShapeGeometry {
    top: number;
    left: number;
    height: number;
    width: number;

    topPadding?: number;
    bottomPadding?: number;
    rightPadding?: number;

    constructor(top: number, left: number, height: number, width: number) {
        this.top = top;
        this.left = left;
        this.height = height;
        this.width = width;
    }

    get topWithPadding(): number {
        return this.top - (this.topPadding ?? 0);
    }

    get heightWithPadding(): number {
        return this.height + (this.topPadding ?? 0) + (this.bottomPadding ?? 0);
    }

    get right(): number {
        return this.left + this.width + (this.rightPadding ?? 0);
    }

    get bottom(): number {
        return this.top + this.height + (this.bottomPadding ?? 0);
    }
}

export class HTMLUtilities {
    static getGeometry(id: string, parentId?: string): HTMLShapeGeometry | undefined {
        let element = document.getElementById(id);
        if (!element) return;

        return this.getGeometryFromElement(element, parentId);
    }

    static getGeometryFromElement(elem: HTMLElement, parentId?: string): HTMLShapeGeometry | undefined {
        let element: HTMLElement | null = elem;
        let top = 0,
            left = 0;
        do {
            top += element.offsetTop || 0;
            left += element.offsetLeft || 0;
            if (parentId && element.offsetParent && element.offsetParent.id === parentId) {
                break;
            } else {
                element = element.offsetParent as HTMLElement;
            }
        } while (element);

        return new HTMLShapeGeometry(top, left, elem.offsetHeight, elem.offsetWidth);
    }
}
